/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Display contexts for quests:
 * - GAMES: Standard game quests shown in the quest carousel
 * - CHALLENGES: Challenge segment quests (auto-set by Challenge system)
 * - GUILDS: Guild-specific quests
 * - LEADERBOARDS: Legacy leaderboard display (deprecated)
 * - PLAYABLE_ADS: Quests tied to playable advertisements
 * - COMPETITIONS: Auto-created quests for Tournaments, Leagues, Leaderboards with EVENT_PIPELINE scoring
 * - PLAY_PAGE: Platform-scoped quests shown on the home Play page (e.g. onboarding), NOT inside any specific game
 * 
 * @export
 */
export const QuestDisplay = {
    GAMES: 'GAMES',
    CHALLENGES: 'CHALLENGES',
    GUILDS: 'GUILDS',
    LEADERBOARDS: 'LEADERBOARDS',
    PLAYABLE_ADS: 'PLAYABLE_ADS',
    COMPETITIONS: 'COMPETITIONS',
    PLAY_PAGE: 'PLAY_PAGE'
} as const;
export type QuestDisplay = typeof QuestDisplay[keyof typeof QuestDisplay];


export function instanceOfQuestDisplay(value: any): boolean {
    for (const key in QuestDisplay) {
        if (Object.prototype.hasOwnProperty.call(QuestDisplay, key)) {
            if (QuestDisplay[key as keyof typeof QuestDisplay] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuestDisplayFromJSON(json: any): QuestDisplay {
    return QuestDisplayFromJSONTyped(json, false);
}

export function QuestDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestDisplay {
    return json as QuestDisplay;
}

export function QuestDisplayToJSON(value?: QuestDisplay | null): any {
    return value as any;
}

export function QuestDisplayToJSONTyped(value: any, ignoreDiscriminator: boolean): QuestDisplay {
    return value as QuestDisplay;
}

